export default __webpack_public_path__ + "static/media/prediction-page-screenshot.29e473de.jpg";